import { DataOverviewCard } from './DataOverviewCard';

export default DataOverviewCard;
